import React from 'react';
import styles from './AllClearZeroState.module.css';

const AllClearZeroState = () => {
  return (
    <div className={styles.container} data-testid="all-clear-zero-state">
      <div className={styles.iconWrapper}>
        {/* Shield with Checkmark Icon */}
        <svg
          className={styles.icon}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
          />
        </svg>
      </div>

      <h2 className={styles.title}>All Clear!</h2>

      <p className={styles.message}>
        No active incidents at this time. All systems are operating normally.
      </p>

      <div className={styles.statusIndicator}>
        <span className={styles.statusDot}></span>
        <span className={styles.statusText}>Systems Operational</span>
      </div>
    </div>
  );
};

export default AllClearZeroState;
